<template>
  <div class="outfit-container">
    <div class="capsule-thumbnail" v-on:click="clicker()">
      <div class="outfit-row top-row">
        <img
          v-for="(layerProduct, index) in outfit.topRow"
          class="outfit-product"
          :key="index"
          :data-product-id="layerProduct.productId"
          :data-layer-id="layerProduct.layerId"
          :src="imageUrl(layerProduct.filename)"
        />
      </div>
      <div class="outfit-row bottom-row">
        <img
          v-for="(layerProduct, index) in outfit.bottomRow"
          class="outfit-product"
          :key="index"
          :data-product-id="layerProduct.productId"
          :data-layer-id="layerProduct.layerId"
          :src="imageUrl(layerProduct.filename)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main";

export default {
  props: {
    outfit: {
      type: Object,
      required: true
    }
  },

  methods: {
    imageUrl(filename) {
      return require(`@/assets/img/anatomy/${filename}.png`);
    },

    clicker() {
      const topRow = this.getOutfitData(this.outfit.topRow);
      const bottomRow = this.getOutfitData(this.outfit.bottomRow);
      const payload = topRow.concat(bottomRow);

      bus.$emit("clickingStitchedOutfit", payload);
    },

    getOutfitData(row) {
      const results = row.map(el => {
        return {
          layerId: parseInt(el.layerId),
          productId: parseInt(el.productId)
        };
      });

      return results;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";
.outfit-container {
  border: 1px solid #e8e8e8;
  background-color: white;
  cursor: pointer;

  .actions-text {
    float: left;
  }

  .actions-icons {
    font-size: 18px;
    float: right;
    margin-top: -5px;
    margin-bottom: 10px;

    i {
      padding: 3px;
    }
  }

  // Main
  .outfit-title {
    text-align: left;
    padding: 10px 0 0px 0;
    text-transform: capitalize;
  }

  .capsule-thumbnail {
    background-color: #fff;
    position: relative;
    width: 100%;
    height: auto;
    display: flex;
    flex-flow: row wrap;
    padding-top: 15px;
    padding-bottom: 15px;
    cursor: pointer;

    .top-row {
      margin-bottom: 10px;
    }

    .outfit-row {
      width: 100%;
      display: flex;
      justify-content: center;

      img.outfit-product {
        padding: 0px;
        margin-left: 5px;
        width: 30px;
        height: 35px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/capsuleAnatomy/CapsuleOutfit.vue